import styled from 'styled-components';
import { Select as MuiSelect } from '@mui/material';

const Select = styled(MuiSelect)``;

export default Select;
